import { type ReactNode } from "react";
import { Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3">
      <div style={{ color: "var(--muted-foreground)" }}>
        {icon ?? <Inbox size={40} strokeWidth={1.2} />}
      </div>
      <h3 className="text-sm font-medium" style={{ color: "var(--text-strong)" }}>
        {title}
      </h3>
      {description && (
        <p className="text-xs max-w-[300px] text-center" style={{ color: "var(--muted-foreground)" }}>
          {description}
        </p>
      )}
      {action && (
        <Button variant="outline" size="sm" onClick={action.onClick} className="mt-2">
          {action.label}
        </Button>
      )}
    </div>
  );
}
